import { dpsTheme } from '../../styles/dpsTheme';

interface StepIndicatorProps {
  currentStep: number;
}

const steps = [
  { number: 1, title: 'Type de logement' },
  { number: 2, title: 'Localisation' },
  { number: 3, title: 'Équipements actuels' }
];

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <nav aria-label="Progress" style={{ marginBottom: dpsTheme.spacing['2xl'] }}>
      <ol style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        '@media (min-width: 640px)': {
          gap: '16px'
        }
      } as any}>
        {steps.map((step, index) => {
          const isActive = currentStep >= step.number;
          const isCompleted = currentStep > step.number;

          return (
            <li key={step.number} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    minWidth: '40px',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    border: `2px solid ${isActive ? dpsTheme.colors.accent.blue.primary : dpsTheme.colors.border.primary}`,
                    background: isActive ? dpsTheme.colors.accent.blue.gradient : dpsTheme.colors.background.card,
                    color: isActive ? '#ffffff' : dpsTheme.colors.text.muted,
                    fontSize: dpsTheme.typography.fontSize.base,
                    fontWeight: dpsTheme.typography.fontWeight.bold,
                    transition: 'all 0.3s',
                    boxShadow: isActive ? dpsTheme.shadows.button : 'none',
                    position: 'relative' as const,
                    flexShrink: 0
                  }}
                >
                  {isCompleted ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  ) : (
                    step.number
                  )}
                </div>

                <div style={{
                  display: 'none',
                  flexDirection: 'column',
                  '@media (min-width: 640px)': {
                    display: 'flex'
                  }
                } as any}>
                  <span
                    style={{
                      fontSize: dpsTheme.typography.fontSize.xs,
                      fontWeight: dpsTheme.typography.fontWeight.semibold,
                      color: isActive ? dpsTheme.colors.text.primary : dpsTheme.colors.text.muted,
                      transition: 'all 0.3s',
                      textTransform: 'uppercase' as const,
                      letterSpacing: '0.5px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {step.title}
                  </span>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div
                  style={{
                    width: '40px',
                    height: '2px',
                    minWidth: '40px',
                    background: isCompleted ? dpsTheme.colors.accent.blue.gradient : dpsTheme.colors.border.secondary,
                    borderRadius: '2px',
                    transition: 'all 0.3s',
                    margin: '0 4px',
                    '@media (min-width: 640px)': {
                      width: '80px',
                      margin: '0 8px'
                    }
                  } as any}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}